<template>
  <div class="report-view" :class="{ 'pdf-report-loading': printingReport }">
      <div class="dash-header">
        <h1>
          <i class="far fa-chart-bar"></i>
          Estatus de operación
          <span v-html="filtersRequiredSet ? filtersHead : 'Seleccione los filtros para los datos del reporte'"></span>
        </h1>
      </div>

      <div v-if="filtersRequiredSet">
        <div v-show="!loadingData">
          <div class="kpis items">
            <div class="indicator-item static-color" v-for="(item, index) in kpis" :key="item.name" :class="[item.color]" :style="{ 'animation-delay': index * 50 + 'ms' }">
              <i class="fal" :class="[item.icon]"></i>
              <h1>{{ item.value | formatNum }} {{ item.suffix }}</h1>
              <label v-html="item.name"/>
            </div>
          </div>

          <div class="row pie-charts" :key="keyCharts" v-if="!refreshingCharts && usersData.users && usersData.users.length > 0">
            <div class="col-xs-12 col-lg-6">
              <div class="kpis animate__animated animate__fadeIn">
                <h2>Tareas</h2>
                <div class="kpi-item chart">
                  <PieChart :chartdata="datacollection.statusTasks" :options="options" style="position: relative; height:280px; width:100%"/>
                </div>
              </div>
            </div>

            <div class="col-xs-12 col-lg-6">
              <div class="kpis charts animate__animated animate__fadeIn">
                <h2>Usuarios</h2>
                <div class="kpi-item chart">
                  <BarChart :chartdata="datacollection.workedUsers" :options="optionsUsersChart" style="position: relative; height:280px; width:100%"/>
                </div>
              </div>
            </div>
          </div>

          <br>

          <div class="kpis page-break" v-if="usersData.users && usersData.users.length > 0">
            <div class="col-xs-12 col-lg-9">
              <table class="table table-hover detail estg scrolled">
                <thead class="table-header">
                  <tr v-if="!printingReport && usersData.users && usersData.users.length >= 20">
                    <td colspan="2">
                      <div class="table-filters">
                        <b-form-input v-model="searchUsers" placeholder="Buscar usuarios"></b-form-input>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <div class="table-users-filters">
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="checkbox" id="filterWorkingUsers" v-model="filterWorkingUsers">
                          <label class="form-check-label" for="filterWorkingUsers">Gestionando</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="checkbox" id="filterWorkingToday" v-model="filterWorkingToday">
                          <label class="form-check-label" for="filterWorkingToday">Gestionando hoy</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="checkbox" id="filterNotWorkingUsers" v-model="filterNotWorkingUsers">
                          <label class="form-check-label" for="filterNotWorkingUsers">Sin gestión</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="checkbox" id="filterNotAssignedUsers" v-model="filterNotAssignedUsers">
                          <label class="form-check-label" for="filterNotAssignedUsers">Sin asignación</label>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col" class="sortable" @click="sortUsernameByManagedTasks" style="width: 170px;">Usuario <i class="fas fa-sort-alpha-down"></i></th>
                    <td scope="col" class="sortable" @click="sortAmountByManagedTasks">Tareas realizadas / pendientes <i class="fas fa-sort-amount-down-alt"></i></td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in usersData.users" :key="index" v-show="visibleUser(item)">
                    <th class="user-name" style="width: 170px;" :class="{ inactive: item.status === 'inactive' }"><span v-if="item.status === 'inactive'"><i class="far fa-user-slash"></i>&nbsp;</span>{{ item.user }}</th>
                    <td>
                      <TableKpiCompareItem v-if="!filterWorkingToday" name="Tareas realizadas" :amount="item.managed" :total="item.managed + item.pending_management" :color="item.isNotAssignedUser ? 'gray' : 'green'" :barColor="item.isNotAssignedUser ? 'gray' : 'yellow'"/>
                      <TableKpiCompareItem v-if="filterWorkingToday" name="Tareas realizadas" :amount="item.managed_today" :total="item.managed_today + item.pending_management" :color="'green'" :barColor="item.isNotAssignedUser ? 'gray' : 'yellow'"/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-xs-12 col-lg-3">
              <div class="status-help">
                <h3><i class="far fa-question-circle"></i> Estatus de usuarios</h3>
                <hr>
                <figure>
                  <blockquote class="blockquote">
                    <p><span class="circle-working"></span>Gestionando</p>
                  </blockquote>
                  <figcaption class="blockquote-footer">
                    Usuarios que por lo menos enviaron una gestión en el periodo y tienen tareas pendientes por gestionar.
                  </figcaption>
                </figure>

                <figure>
                  <blockquote class="blockquote">
                    <p><span class="circle-not-working"></span>Sin gestión</p>
                  </blockquote>
                  <figcaption class="blockquote-footer">
                    Usuarios que tienen asignación, pero no han enviado una gestión a la plataforma en el periodo.
                  </figcaption>
                </figure>

                <figure>
                  <blockquote class="blockquote">
                    <p><span class="circle-not-assigned"></span>Sin asignación</p>
                  </blockquote>
                  <figcaption class="blockquote-footer">
                    Usuarios que no tienen asignación por gestionar o ya enviaron todas sus gestiones.
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>

          <h3 class="no-data-message" v-if="!usersData.users || usersData.users.length === 0">No se encontraron datos para los filtros seleccionados</h3>
        </div>

        <div v-if="loadingData" class="mock-loading">
          <div class="kpis items">
            <div class="indicator-item animate__animated animate__shakeX" v-for="index in 5" :key="index"></div>
          </div>

          <div class="kpis">
            <div class="kpi-item chart animate__animated animate__shakeX"></div>
          </div>
        </div>

      </div>

      <div v-else class="default-image">
        <img src="@/assets/img/reports/status-management.svg">
      </div>

      <a class="hidden-csv-download-link" ref="csvDownload"></a>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import moment from 'moment'

import { AbstractReportComponent } from './AbstractReportComponent'
import TableKpiCompareItem from '@/components/dashboard/TableKpiCompareItem.vue'
import { KpiItem, FiltersDateFormats, KpisStatusManagement, KpisUserStatusManagement, KpisStatusManagementData } from '@/types/Dashboard'
import PieChart from '@/components/charts/PieChart.vue'
import BarChart from '@/components/charts/BarChart.vue'
import Colors from '@/types/Colors'
import reportsService from '@/services/ReportsService'

@Component({
  components: {
    TableKpiCompareItem,
    PieChart,
    BarChart
  },
  filters: {
    formatNum (value: number) {
      return value.toLocaleString('en')
    }
  }
})
export default class ReportEstatusGestion extends AbstractReportComponent {
  usersData = new KpisStatusManagementData()
  mainKpis = new KpisStatusManagement()

  // Main KPIs
  kpis: KpiItem[] = []

  searchUsers = ''
  filterWorkingUsers = false
  filterNotWorkingUsers = false
  filterNotAssignedUsers = false
  filterWorkingToday = false

  tableUsernameSortDirAsc = true
  tableAmountSortDirAsc = false

  // Charts
  refreshingCharts = false
  datacollection: any = {
    workedUsers: null,
    statusTasks: null
  }

  options = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      callbacks: {
        label: (tooltipItem: any, data: any) => {
          let valueNum = Number(data.datasets[0].data[tooltipItem.index] || 0)
          return valueNum.toLocaleString('en')
        }
      }
    },
    plugins: {
      datalabels: {
        anchor: 'begin',
        align: 'end',
        textAlign: 'center',
        color: '#fff',
        textShadowBlur: 3,
        textShadowColor: '#000',
        font: {
          weight: 'bold',
          size: 14
        },
        formatter: (value: any, ctx: any) => {
          if (!value) return ''
          let datasets = ctx.chart.data.datasets
          let percentage = ''
          if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {
            let sum = datasets[0].data.reduce((a: number, b: number) => a + b, 0)
            percentage = value.toLocaleString('en') + '\n(' + Math.round((value / sum) * 100) + '%)'
            return percentage
          } else {
            return percentage
          }
        }
      }
    }
  }

  optionsUsersChart = {
    legend: { display: false },
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      callbacks: {
        label: (tooltipItem: any, data: any) => {
          let valueNum = Number(data.datasets[0].data[tooltipItem.index] || 0)
          return valueNum.toLocaleString('en')
        }
      }
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          precision: 0
        }
      }]
    },
    plugins: {
      datalabels: {
        color: '#fff',
        textShadowBlur: 4,
        textShadowColor: '#000',
        font: {
          weight: 'bold',
          size: 15
        },
        align: 'top',
        anchor: 'begin',
        formatter: (value: any, ctx: any) => {
          let datasets = ctx.chart.data.datasets
          let percentage = ''
          if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {
            let sum = datasets[0].data.reduce((a: number, b: number) => a + b, 0)
            percentage = value + ' (' + Math.round((value / sum) * 100) + '%)'
            return percentage
          } else {
            return percentage
          }
        }
      }
    }
  }

  keyCharts = 0

  created () {
    this.$store.commit('global/updateFiltersReportEstatusGestion')
  }

  mounted () {
    this.initialPageTitle = document.title
    this.filter(this.$route.query as any)
    this.$root.$on('export-report', this.exportReport)
    window.addEventListener('afterprint', this.afterPrintPdfReport)
  }

  beforeDestroy () {
    document.title = this.initialPageTitle
    this.$root.$off('export-report', this.exportReport)
    window.removeEventListener('afterprint', this.afterPrintPdfReport)
  }

  get filtersRequiredSet () {
    return !!this.filters.template && !!this.filters.group
  }

  resetReportValues () {
    this.usersData = new KpisStatusManagementData()
    this.mainKpis = new KpisStatusManagement()
    this.kpis = []
  }

  async refreshData () {
    if (!this.filtersRequiredSet) return

    this.loadingData = true
    this.$store.commit('global/lockReportFilters', true)

    this.tableUsernameSortDirAsc = true
    this.tableAmountSortDirAsc = false

    try {
      await reportsService.getEstatusGestion(this.filters)
        .then((response) => { this.usersData = response })
        .catch(() => {
          this.endPrint()
          this.$store.commit('global/lockReportFilters', false)
          this.resetReportValues()
        })

      this.sortAmountByManagedTasks()

      const kpis = reportsService.getStatusManagementKpis(this.usersData)
      this.mainKpis = kpis
      this.refreshMainKpis(kpis)
      this.refreshChartsKpis(kpis)
    } finally {
      setTimeout(() => {
        this.loadingData = false
        this.$store.commit('global/lockReportFilters', false)
      }, 500)
    }
  }

  refreshFiltersInfo () {
    let result = []

    if (this.filtersStore.template) {
      result.push(this.filtersStore.templateName)
    }

    if (this.filtersStore.group) {
      result.push('Grupo: ' + this.filtersStore.groupName)
    }

    const date = 'Del ' + moment(this.filtersStore.endDate, FiltersDateFormats.QUERY_STRING).format('D [de] MMMM [de] YYYY')
    result.push(date)

    this.filtersHead = result.join(', ')
  }

  refreshMainKpis (kpis: KpisStatusManagement) {
    this.kpis = []

    this.kpis.push(
      KpiItem.getInstance().withName('Total<br>de tareas').withValue((kpis.sumManagedTasks || 0) + (kpis.sumPendingManagement || 0) + (kpis.unassignedTasks || 0)).withIcon('fa-clipboard-list').withColor('aqua')
    )

    this.kpis.push(
      KpiItem.getInstance().withName('Tareas gestionadas<br>en el periodo').withValue(kpis.sumManagedTasks).withIcon('fa-map-marker-check').withColor('green')
    )

    this.kpis.push(
      KpiItem.getInstance().withName('Tareas pendientes<br>de gestionar').withValue(kpis.sumPendingManagement).withIcon('fa-map-marker-exclamation').withColor('yellow')
    )

    if (kpis.unassignedTasks !== undefined) {
      this.kpis.push(
        KpiItem.getInstance().withName('Tareas pendientes<br>de asignar').withValue(kpis.unassignedTasks || 0).withIcon('fa-clipboard-list-check').withColor('gray')
      )
    }

    this.kpis.push(
      KpiItem.getInstance().withName(`Usuarios<br>productivos`).withValue(kpis.sumActiveUsers).withIcon('fa-street-view').withColor('purple')
    )
  }

  refreshChartsKpis (kpis: KpisStatusManagement) {
    this.refreshingCharts = true

    this.datacollection.workedUsers = {
      labels: ['Usuarios gestionando', 'Usuarios sin gestión', 'Usuarios sin asignación'],
      datasets: [
        {
          backgroundColor: [ Colors.green[1], Colors.yellow[1], Colors.gray[0] ],
          data: [ kpis.sumWorkingUsers, kpis.sumNotWorkingUsers, kpis.sumNotAssignedUsers ]
        }
      ]
    }

    let statusTasksLabels = ['Realizadas', 'Pendientes de gestionar']
    let statusTasksData = [ kpis.sumManagedTasks, kpis.sumPendingManagement ]
    let statusTasksBackgroundColor = [ Colors.green[0], Colors.yellow[1] ]

    if (kpis.unassignedTasks !== undefined) {
      statusTasksBackgroundColor.push(Colors.gray[0])
      statusTasksLabels.push('Pendientes de asignar')
      statusTasksData.push(kpis.unassignedTasks)
    }

    this.datacollection.statusTasks = {
      labels: statusTasksLabels,
      datasets: [
        {
          label: 'Tareas',
          backgroundColor: statusTasksBackgroundColor,
          data: statusTasksData
        }
      ]
    }

    setTimeout(() => {
      this.refreshingCharts = false
    }, 500)
  }

  visibleUser (userItem: KpisUserStatusManagement) {
    let visible = !this.searchUsers || userItem.user.includes(this.searchUsers)
    if (visible && (this.filterWorkingUsers || this.filterWorkingToday || this.filterNotWorkingUsers || this.filterNotAssignedUsers)) {
      visible = (this.filterWorkingUsers && userItem.isWorkingUser) ||
                (this.filterWorkingToday && userItem.managed_today > 0) ||
                (this.filterNotWorkingUsers && userItem.isNotWorkingUser) ||
                (this.filterNotAssignedUsers && userItem.isNotAssignedUser)
    }
    return visible
  }

  sortAmountByManagedTasks () {
    if (this.tableAmountSortDirAsc) {
      this.usersData.users.sort((a, b) => (a.managed > b.managed) ? 1 : -1)
    } else {
      this.usersData.users.sort((a, b) => (a.managed < b.managed) ? 1 : -1)
    }
    this.tableAmountSortDirAsc = !this.tableAmountSortDirAsc
  }

  sortUsernameByManagedTasks () {
    if (this.tableUsernameSortDirAsc) {
      this.usersData.users.sort((a, b) => (a.user > b.user) ? 1 : -1)
    } else {
      this.usersData.users.sort((a, b) => (a.user < b.user) ? 1 : -1)
    }
    this.tableUsernameSortDirAsc = !this.tableUsernameSortDirAsc
  }

  exportReport (reportType: string) {
    switch (reportType) {
      case 'pdf':
        this.generatePdfReport()
        break
      case 'csv':
        this.generateCsvReport()
        break
    }
  }

  generatePdfReport () {
    this.validateRatio()
    this.keyCharts = new Date().getTime()
    this.searchUsers = ''
    this.startPrint()
    setTimeout(() => {
      window.print()
    }, 1200)
  }

  generateCsvReport () {
    let csv = this.mainKpis.unassignedTasks !== undefined ? 'FECHA,USUARIO,ESTATUS,TOTAL TAREAS,TAREAS REALIZADAS,TAREAS REALIZADAS HOY,TAREAS PENDIENTES DE GESTIONAR,TAREAS PENDIENTES DE ASIGNAR,% TAREAS REALIZADAS,% TAREAS PENDIENTES DE GESTIONAR,% TAREAS PENDIENTES DE ASIGNAR\n'
      : 'FECHA,USUARIO,ESTATUS,TOTAL TAREAS,TAREAS REALIZADAS,TAREAS REALIZADAS HOY,TAREAS PENDIENTES DE GESTIONAR,% TAREAS REALIZADAS,% TAREAS PENDIENTES DE GESTIONAR\n'

    let totalUserTasks = 0
    let managedTaskPercent = ''
    let pendingTaskPercent = ''
    let statusUser = ''
    let period = moment(this.filtersStore.endDate, FiltersDateFormats.QUERY_STRING).format('D/MM/YYYY')
    csv += this.mainKpis.unassignedTasks !== undefined ? '' +
        `${period},Todos,--,${this.mainKpis.totalTasks},${this.mainKpis.sumManagedTasks},${this.mainKpis.sumManagedTasksToday},${this.mainKpis.sumPendingManagement},${this.mainKpis.unassignedTasks},${(this.mainKpis.sumManagedTasks / this.mainKpis.totalTasks * 100).toFixed(1)} %,${(this.mainKpis.sumPendingManagement / this.mainKpis.totalTasks * 100).toFixed(1)} %,${(this.mainKpis.unassignedTasks / this.mainKpis.totalTasks * 100).toFixed(1)} %\n`
      : `${period},Todos,--,${this.mainKpis.totalTasks},${this.mainKpis.sumManagedTasks},${this.mainKpis.sumManagedTasksToday},${this.mainKpis.sumPendingManagement},${(this.mainKpis.sumManagedTasks / this.mainKpis.totalTasks * 100).toFixed(1)} %,${(this.mainKpis.sumPendingManagement / this.mainKpis.totalTasks * 100).toFixed(1)} %\n`

    for (let it of this.usersData.users) {
      totalUserTasks = it.managed + it.pending_management
      if (totalUserTasks) {
        managedTaskPercent = (it.managed / totalUserTasks * 100).toFixed(1)
        pendingTaskPercent = (it.pending_management / totalUserTasks * 100).toFixed(1)
      } else {
        managedTaskPercent = '0.0'
        pendingTaskPercent = '0.0'
      }
      if (it.isWorkingUser) statusUser = 'GESTIONANDO'
      if (it.isNotWorkingUser) statusUser = 'SIN GESTION'
      if (it.isNotAssignedUser) statusUser = 'SIN ASIGNACION'
      csv += this.mainKpis.unassignedTasks !== undefined ? `${period},${it.user},${statusUser},${totalUserTasks},${it.managed},${it.managed_today},${it.pending_management},,${managedTaskPercent} %,${pendingTaskPercent} %\n`
        : `${period},${it.user},${statusUser},${totalUserTasks},${it.managed},${it.managed_today},${it.pending_management},${managedTaskPercent} %,${pendingTaskPercent} %\n`
    }

    const periodTitle = moment(this.filtersStore.endDate, FiltersDateFormats.QUERY_STRING).format('DDMMYYYY')

    let element = this.$refs.csvDownload as any
    element.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
    element.target = '_blank'
    element.download = `${periodTitle}_${this.filtersStore.templateName}_${this.filtersStore.groupName}_RptEstatusGestion.csv`
    element.click()
  }

  afterPrintPdfReport () {
    this.endPrint()
    document.title = this.initialPageTitle
  }
}
</script>

<style lang="scss" scoped>
.default-image {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100% - 120px);
  overflow: visible;
  img {
    width: 50%;
    min-width: 350px;
    opacity: 0.2;
  }
}

.table-filters {
  width: 350px;
  margin: 10px 0;
}

.table-users-filters {
  display: flex;
  align-items: center;
  padding: 7px 0;

  label {
    cursor: pointer;
  }

  input[type=checkbox] {
    cursor: pointer;
    width: 18px;
    height: 18px;
    &:checked {
      box-shadow: 0 0 1px 1px #fff;
    }
  }
}

.centered-grid-users {
  flex-direction: column;
  align-items: center;
}

.status-help {
  box-shadow: 1px 1px 10px -2px #ccc;
  padding: 15px;
  background-color: #fff;
  h3 {
    font-size: 1rem;
  }
  .blockquote {
    outline: none;
    border: 0;
    font-size: 1rem;
    margin-bottom: 7px;
    p {
      margin: 0;
      span {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-right: 7px;
        &.circle-working {
          background-color: #37bc9b;
        }
        &.circle-not-working {
          background-color: #f6bb42;
        }
        &.circle-not-assigned {
          background-color: #858585;
        }
      }
    }
  }
}

.pdf-report-loading .pie-charts {
  display: block;
  *[class^='col-'] {
    max-width: 100%;
  }

  .kpi-item.chart > div {
    height: 450px !important;
    background-color: #f8f8f8;
    padding: 20px;
    border-radius: 7px;
  }
}

.no-data-message {
  text-align: center;
  max-width: 450px;
  margin: 0 auto;
  padding-top: 5%;
  color: #acacac;
}
</style>
